export const translations = {
  en: {
    title: 'Hör-Stimme: Voice Bridge',
    intro: 'Hörstimme transforms your voice into a different voice in real time — right in your browser, no installation required.\nPick a target voice, start speaking, and hear the result instantly.',
    chooseVoice: 'Choose voice:',
    loading: 'Loading...',
    modes: {
      interval: 'Interval',
      silence: 'Silence-Based',
      hybrid: 'Hybrid',
      full: 'Full Recording',
    },
    start: '🎙️ Start',
    stop: '🛑 Stop',
    playing: 'Playing...',
    ready: 'Ready',
    instructionsToggle: 'ℹ️ Instructions',
    instructionsTitle: 'How to use this demo',
    steps: [
      { heading: '1. Choose a voice', text: 'Select the target voice from the dropdown at the top.' },
      { heading: '2. Choose a mode', text: 'Interval: sends a chunk every 2 seconds. \nSilence-Based: sends as soon as you pause speaking briefly. \nHybrid: a mix of both. \nFull Recording: records everything and converts it only after you stop.' },
      { heading: '3. Start recording', text: 'Click "🎙️ Start" and allow microphone access if prompted. Speak normally — the converted voice will play back automatically shortly after.' },
      { heading: '4. Stop recording', text: 'Click "🛑 Stop" to end the recording.' },
    ],
  },
  de: {
    title: 'Hör-Stimme: Voice Bridge',
    intro: 'Hörstimme wandelt deine Stimme in Echtzeit in eine andere Stimme um – direkt im Browser, ganz ohne Installation.\nWähle eine Zielstimme, sprich einfach los, und hör dir sofort an, wie es klingt.',
    chooseVoice: 'Stimme wählen:',
    loading: 'Lädt...',
    modes: {
      interval: 'Intervall',
      silence: 'Pausenbasiert',
      hybrid: 'Hybrid',
      full: 'Komplettaufnahme',
    },
    start: '🎙️ Start',
    stop: '🛑 Stopp',
    playing: 'Spielt ab...',
    ready: 'Bereit',
    instructionsToggle: 'ℹ️ Anleitung',
    instructionsTitle: 'So funktioniert die Bedienung',
    steps: [
      { heading: '1. Stimme wählen', text: 'Wähle oben im Dropdown die gewünschte Zielstimme aus.' },
      { heading: '2. Modus wählen', text: 'Interval: sendet alle 2 Sekunden einen Ausschnitt. \nSilence-Based: sendet, sobald du eine kurze Sprechpause machst. \nHybrid: Mischung aus beidem. \nFull Recording: nimmt alles auf und wandelt erst nach dem Stoppen um.' },
      { heading: '3. Aufnahme starten', text: 'Klicke auf „🎙️ Start" und erlaube den Mikrofonzugriff, falls gefragt. Sprich normal – die umgewandelte Stimme wird kurz danach automatisch abgespielt.' },
      { heading: '4. Aufnahme stoppen', text: 'Klicke auf „🛑 Stop", um die Aufnahme zu beenden.' },
    ],
  },
};